//# sourceMappingURL=keyframe.mjs.map
/// <reference types="./keyframe.d.mts" />
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import { CustomType as $CustomType } from "../../gleam.mjs";
import * as $style from "../../sketch/internals/cache/cache.mjs";

class Keyframe extends $CustomType {
  constructor(class$) {
    super();
    this.class = class$;
  }
}

/**
 * A starting offset of `0%`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/@keyframes#from)
 */
export function from(styles) {
  return new Keyframe($style.named("from", styles));
}

/**
 * An ending offset of `100%`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/@keyframes#to)
 */
export function to(styles) {
  return new Keyframe($style.named("to", styles));
}

/**
 * A percentage of the time through the animation sequence at which the
 * specified keyframe should occur.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/@keyframes#percentage)
 */
export function at(percentage, styles) {
  return new Keyframe($style.named($int.to_string(percentage) + "%", styles));
}

/**
 * Internal function, can be used if you need to go from a keyframe to a String
 * in case you're building on top of sketch.
 * 
 * @ignore
 */
export function class$(keyframe) {
  return keyframe.class;
}
